<template>
    <div>
        <CajitaOscilo :osciloProp="oscilo" :vistaMapaProp="false" :vistaCuadriculaProp="false" :vistaDetalleProp="true">
        </CajitaOscilo>
    </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue';
import CajitaOscilo from './CajitaOscilo.vue';
import type { OsciloDetalleModel } from '@/.shared/.api';

const props = defineProps<{ osciloProp: OsciloDetalleModel }>();
const oscilo = computed(() => props.osciloProp);
</script>